"use strict";

class BiomeModifier{
    constructor(biome, modifier) {
        this.biome = biome;
        this.modifier = modifier;
    }
}

export default BiomeModifier;
